import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flexbox;
  align-items: center;
  width: auto;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 120%;
  margin-bottom: 8px;
  margin-right: 16px;
  @media ${MEDIA_QUERIES.laptopL} {
    width: 100%;
    display: flex;
    margin-right: 0;
  }
`;

export const ImageContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;

export const Column = styled.div<{ alignRight?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ alignRight }) => alignRight && 'flex-end'};
  width: auto;
  @media ${MEDIA_QUERIES.laptopL} {
    width: 100%;
  }
`;

export const Text = styled.span<{ bold?: boolean; isName?: boolean }>`
  display: ${({ isName }) => isName && 'none'};
  min-width: 40px;
  margin-left: 8px;
  font-weight: ${({ bold }) => bold && 600};
  @media ${MEDIA_QUERIES.laptopL} {
    display: inline;
    margin-left: 12px;
  }
`;

export const Perc = styled.span<{ negative?: boolean }>`
  color: ${({ theme, negative }) => (negative ? theme.colors.warning : theme.colors.success)};
  margin-left: 8px;
  @media ${MEDIA_QUERIES.laptopL} {
    margin: 0;
  }
`;
